export function ErrorRetry({ message, onRetry }: { message: string; onRetry: () => void }) {
  return (
    <div className="mx-auto max-w-md border border-line border-l-4 border-l-bad bg-surface p-6 text-center">
      <p className="text-sm text-ink-900">{message}</p>
      <button
        type="button"
        onClick={onRetry}
        className="mt-4 bg-felt-700 px-4 py-2 text-xs font-bold uppercase tracking-[0.08em] text-white transition hover:bg-felt-900"
      >
        Retry
      </button>
    </div>
  );
}
